import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HubConnectionState } from '@microsoft/signalr';

@Component({
  selector: 'app-admin-console-row',
  templateUrl: './admin-console-row.component.html',
  styleUrls: ['./admin-console-row.component.scss'],
})
export class AdminConsoleRowComponent implements OnInit {
  @Input() title = '';
  @Input() status!: BehaviorSubject<string>;
  @Input() error!: BehaviorSubject<string>;
  @Output() sendMessage = new EventEmitter();
  @Output() refresh = new EventEmitter();

  get bgColor(): string {
    switch (this.status.getValue()) {
      case HubConnectionState.Connected:
        return 'green';
      case HubConnectionState.Disconnected:
        return 'red';
      case HubConnectionState.Connecting:
      case HubConnectionState.Disconnecting:
      case HubConnectionState.Reconnecting:
        return 'orangered';
      default:
        return 'transparent';
    }
  }

  constructor() {}

  ngOnInit(): void {}
}
